import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const Footer = () => {
  const { user } = useAuth();
  const cta = user ? (user.role === "admin" ? { to: "/admin", text: "Members" } : { to: "/dashboard", text: "My profile" }) : { to: "/register", text: "Join now" };
  return (
  <footer className="bg-[hsl(0,0%,3%)] border-t border-white/10 mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 grid md:grid-cols-12 gap-12">
      <div className="md:col-span-8">
        <p className="label-xs mb-6">Ready for your close-up?</p>
        <Link
          to={cta.to}
          className="group font-display text-5xl md:text-7xl font-bold leading-none inline-flex items-end gap-4 hover:text-primary transition-colors"
          data-testid="footer-join-cta"
        >
          {cta.text}
          <ArrowUpRight className="w-12 h-12 md:w-16 md:h-16 transition-transform duration-300 group-hover:-translate-y-2 group-hover:translate-x-2" />
        </Link>
        <p className="text-white/50 mt-6 max-w-md">Your own web address, your photos, in front of the people casting crowds. First 6 months FREE, then £10 / $14 / €12 a year.</p>
      </div>
      <div className="md:col-span-4 flex flex-col gap-3 md:items-end md:justify-end text-sm text-white/60">
        <Link to="/search" className="hover:text-white transition-colors" data-testid="footer-search-link">Find extras</Link>
        <Link to="/casting-calls" className="hover:text-white transition-colors" data-testid="footer-casting-calls-link">Casting calls</Link>
        <Link to="/casting-request" className="hover:text-white transition-colors" data-testid="footer-casting-request-link">Request extras for a production</Link>
        <Link to="/uk" className="hover:text-white transition-colors" data-testid="footer-uk-link">Extras in the UK</Link>
        <Link to="/usa" className="hover:text-white transition-colors" data-testid="footer-usa-link">Extras in the USA</Link>
        <Link to="/ireland" className="hover:text-white transition-colors" data-testid="footer-ireland-link">Extras in Ireland</Link>
        <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms-link">Terms & Conditions</Link>
        <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Notice</Link>
        <Link to="/data-protection" className="hover:text-white transition-colors" data-testid="footer-data-protection-link">Membership & Data Protection</Link>
        {!user && <Link to="/login" className="hover:text-white transition-colors" data-testid="footer-login-link">Member log in</Link>}
        <p className="mt-6 font-display text-xl text-white">extras<span className="text-primary">.tv</span></p>
        <p className="text-white/40">© {new Date().getFullYear()} extras.tv</p>
      </div>
    </div>
  </footer>
  );
};
